import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, Lock, Smartphone, Monitor } from 'lucide-react';

export default function AuthPage() {
  const navigate = useNavigate();

  // Check if authentication is disabled and redirect to home
  useEffect(() => {
    const isAuthDisabled = import.meta.env.VITE_DISABLE_AUTH === 'true';
    if (isAuthDisabled) {
      navigate('/');
    }
  }, [navigate]);

  const handleStartDeviceAuth = () => {
    navigate('/auth/device');
  };

  const handleManualAuth = () => {
    navigate('/auth/manual');
  };

  const handleClose = () => {
    navigate('/');
  };

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Main content - centered */}
      <div className="flex-1 flex items-center justify-center p-4">
        <Card className="w-full max-w-md mx-auto">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <Shield className="h-12 w-12 text-primary" />
            </div>
            <CardTitle className="flex items-center justify-center gap-2">
              <Lock className="h-5 w-5" />
              Authentication Required
            </CardTitle>
            <CardDescription>
              To access the Q&A service, you need to authorize this device. Choose one of the options below:
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button 
              onClick={handleStartDeviceAuth}
              className="w-full flex items-center gap-2"
            >
              <Smartphone className="h-4 w-4" />
              Start Device Authorization
            </Button>
            
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-background px-2 text-muted-foreground">Or</span>
              </div>
            </div>
            
            <Button 
              variant="outline" 
              onClick={handleManualAuth}
              className="w-full flex items-center gap-2"
            >
              <Monitor className="h-4 w-4" />
              Enter User Code Manually
            </Button>
          </CardContent>
        </Card>
      </div>

      {/* Bottom actions */}
      <div className="p-6 bg-white border-t">
        <div className="max-w-md mx-auto">
          <Button 
            variant="outline" 
            onClick={handleClose}
            className="w-full"
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}